<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.customerName" placeholder="请输入名称"></el-input>
					</el-form-item>
					

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="add">新增客户
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="storeList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="username" label="用户名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeType" label="店铺类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.storeType==0">线上店铺</p>
					<p v-if="scope.row.storeType==1">九天小超</p>
				</template>
			</el-table-column>
			<el-table-column prop="storeLogo" label="店铺LOGO" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img :src="scope.row.storeLogo" style="width: 60px;height: 60px;border-radius: 10px;" />
				</template>
			</el-table-column>
			<el-table-column prop="deposit" label="店铺余额" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="店铺状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0" style="color: red;">停用</p>
					<p v-if="scope.row.status==1">正常</p>
				
				</template>
			</el-table-column>
			<el-table-column prop="checkState" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.checkState==0" style="color: red;">待审核</p>
					<p v-if="scope.row.checkState==1"  style="color: green;">已通过</p>
					<p v-if="scope.row.checkState==2"  style="color: red;">已驳回</p>
				
				</template>
			</el-table-column>
			<el-table-column prop="refuseReason" label="驳回原因" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<!-- <el-table-column prop="status" label="店铺状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0">停用</p>
					<p v-if="scope.row.status==1">正常</p>
				</template>
			</el-table-column> -->
			
			<el-table-column prop="address" label="店铺地址"  align="center" :show-overflow-tooltip="true">
				<template v-slot="scope">
				<span>
						{{ scope.row.province ? scope.row.province : ""}}
						{{ scope.row.city ? scope.row.city : ""}}
						{{ scope.row.area ? scope.row.area : ""}}
						{{ scope.row.address ? scope.row.address : "" }}
					</span>
				</template>
			</el-table-column>
			
			<el-table-column prop="createTime" label="注册时间" width="100px" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="updateTime" label="更新时间" width="100px" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column label="操作" fixed="right" width="160px" align="center">
				　<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id,scope.row.storeClassId);title='编辑'">编辑
					</el-button>
					<el-button size="small" type="text" 
					v-if="scope.row.checkState == 0"  @click="toExamine(scope.row.id);">审核
					</el-button>
					<el-dropdown trigger="click" style="margin-left: 10px;">

						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-if="scope.row.checkState==2" >驳回
							</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.status==1" @click.native="toDelete(scope.row)">禁用
							</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.status==0" @click.native="toDelete(scope.row)">启用
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="storeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="storeList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 审核驳回 -->
		<el-dialog style="float:rigin" title="审核驳回" :visible.sync="editDialogVisible" width="35%"
			:closeOnClickModal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" size="medium">
					<el-form-item label="驳回原因:">
						<el-col :span="18">
							<el-input v-model="form.refuseReason" type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="请输入驳回原因" />
						</el-col>
					</el-form-item>
					<el-form-item style="text-align: center;">
						<el-button :loading="loading" type="primary" @click="editStoreInfoCheck(storeId,2)">提交
						</el-button>
						<el-button @click="cannelPass">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<!-- 新增商家 -->
		<el-dialog :closeOnClickModal="false" style="float:rigin" title="新增" :visible.sync="dialogVisibleAdd"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="请选择用户">
						
							<el-input type="text"  v-model="userName"
									placeholder="请输入用户名称(搜索条件)" @input="inputHandler" clearable />
                <div class="searchBox" v-show="isSearchShow">
                  <p v-for="item in accountList1" :key="item.id" @click="selectStore(item.id,item.username)">{{ item.username }}</p>
                </div>
					</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="公司名称" style="margin-right: 20px;">
							<el-input type="text" v-model="storeInfo.companyName" placeholder="请输入公司名称" />
						</el-form-item>
						<el-form-item label="是否开小超" class="redItem" style="flex: 25%;">
							<el-switch v-model="isXiaochao">
							</el-switch>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;" v-if="isXiaochao">
						<el-form-item label="店铺名称">
							<el-input type="text" v-model="storeInfo.storeName" placeholder="请输入店铺名称" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="手机号">
							<el-input type="text" v-model="storeInfo.phone" placeholder="请输入手机号" />
						</el-form-item>
						<el-form-item label="联系人">
							<el-input type="text" v-model="storeInfo.linkUser" placeholder="请输入联系人" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="省/市/区">
							<el-col :span="13.5">
								<el-select clearable filterable v-model="storeInfo.provinceId" placeholder="请选择省"
									style="width:120px;margin-right:10px;" @change="provinceFocus">
									<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
								<el-select clearable filterable v-model="storeInfo.cityId" placeholder="请选择市"
									style="width:120px;margin:  0px 10px;" @change="cityFcus">
									<el-option v-for="item in cityList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
								<el-select clearable filterable v-model="storeInfo.areaId" placeholder="请选择区"
									style="width:120px;margin:  0px 10px;" @change="districtFcus">
									<el-option v-for="item in districtList" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</el-col>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="详细地址">
							<el-input type="text" v-model="storeInfo.address" placeholder="请输入详细地址" />
						</el-form-item>
					</div>
					
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label="isXiaochao ? '店铺Logo' : 'Logo'">
							<!-- 图片上传 -->
							<el-upload class="avatar-uploader" :action="httpUrl" :on-preview="handlePreview"
								:before-upload="beforeAvatarUpload" :on-success="onSuccess" :show-file-list="false">
								<img style="width: 100px;height: 100px;" v-if="logo" :src="logo" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label="isXiaochao ? '店铺证件照片' : '证件照片'">
							<!-- 图片上传 -->
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :limit="5"
								:on-success="onSuccess1">
								<i class="el-icon-plus"></i>
							</el-upload>

						</el-form-item>
					</div>

					<div>
						<div style="text-align: start;margin: 10px;">{{isXiaochao ? `店铺简介` : `公司简介`}}</div>
						<el-form-item>
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess"
									:on-error="uploadError" />
								<quill-editor v-model="storeInfo.storeIntro" ref="myQuillEditor" class="editer"
									:options="editorOption" @ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogVisibleAdd = false">取 消</el-button>
				<el-button type="primary" @click="sure">添 加</el-button>
			</div>
		</el-dialog>

		<!-- 编辑商家 -->
		<el-dialog :closeOnClickModal="false" style="float:rigin" :title="title" :visible.sync="dialogVisible"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商家类型" cleartable v-if="isXiaochao">
							<el-select  v-model="storeInfo.storeType" placeholder="请选择" >
								<el-option key="0" label="电商线上" :value="0">电商线上</el-option>
								<el-option key="1" label="九天小超" :value="1">九天小超</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="经营类别:" cleartable v-if="isXiaochao">
							
							<el-select   v-model="storeInfo.storeClassId" class="big" placeholder="请选择" clear
								:remote-method="remoteMethod" @change="getCate">
								<el-option v-for="item in category" :key="item.id" :value="item.id"
									:label="item.className">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="用户名称">
							<el-input v-model="storeInfo.username" disabled></el-input>
							<!-- <el-select v-if="title=='新增'" filterable remote  v-model="storeInfo.userId" class="big" placeholder="请选择" clear
								:remote-method="remoteMethod" @change="getUserId">
								<el-option v-for="item in accountList1" :key="item.id" :value="item.id"
									:label="item.username">
								</el-option>
							</el-select>
							<el-select v-if="title=='编辑'" filterable remote disabled v-model="storeInfo.userId" class="big" placeholder="请选择" clear
								:remote-method="remoteMethod" @change="getUserId">
								<el-option v-for="item in accountList1" :key="item.id" :value="item.id"
									:label="item.username">
								</el-option>
							</el-select> -->
						</el-form-item>
					</div>
					<!-- <div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商家级别">
							<el-select clearable filterable v-model="storeInfo.storeLevel" placeholder="请选择省"
							style="width:120px;margin-right:10px;">
								<el-option v-for="item in storeLevelList" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</div> -->
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="公司名称">
							<el-input type="text" v-model="storeInfo.companyName" placeholder="请输入公司名称" />
						</el-form-item>
						<el-form-item label="店铺名称" v-if="isXiaochao">
							<el-input type="text" v-model="storeInfo.storeName" placeholder="请输入店铺名称" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
					

						<el-form-item label="手机号">
							<el-input type="text" v-model="storeInfo.phone" placeholder="请输入手机号" />
						</el-form-item>
						<el-form-item label="联系人">
							<el-input type="text" v-model="storeInfo.linkUser" placeholder="请输入联系人" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;" v-if="isXiaochao">
						<el-form-item label="店铺日提现额:">
							<el-input v-if="title=='新增'" type="text" disabled v-model="storeInfo.limitDayAmount" placeho
							lder="请输入店铺日提现额" />
							<el-input v-if="title=='编辑'" type="text"  v-model="storeInfo.limitDayAmount" placeholder="请输入店铺日提现额" />
						</el-form-item>
							
					</div>
					<el-form-item label="服务区域" v-if="isXiaochao">
						<el-input  style="width: 350px;" type="textarea"  show-word-limit v-model="storeInfo.serviceAreas" placeholder="请选择您的店铺可服务的区域或者范围" />
					</el-form-item>
					
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="省/市/区">
							<el-col :span="13.5">
								<el-select clearable filterable v-model="storeInfo.provinceId" placeholder="请选择省"
									style="width:120px;margin-right:10px;" @change="provinceFocus">
									<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
								<el-select clearable filterable v-model="storeInfo.cityId" placeholder="请选择市"
									style="width:120px;margin:  0px 10px;" @change="cityFcus">
									<el-option v-for="item in cityList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
								<el-select clearable filterable v-model="storeInfo.areaId" placeholder="请选择区"
									style="width:120px;margin:  0px 10px;" @change="districtFcus">
									<el-option v-for="item in districtList" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</el-col>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<!-- <el-form-item label="商家类型" cleartable>
							<el-select v-model="storeInfo.type" placeholder="请选择">
								<el-option key="0" label="线上" :value="0">线上</el-option>
								<el-option key="1" label="社区店" :value="1">社区店</el-option>
							</el-select>
						</el-form-item> -->


						<el-form-item label="详细地址">
							<el-input type="text" v-model="storeInfo.address" placeholder="请输入详细地址" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						
						<el-form-item label="营业时间" v-if="isXiaochao">
							<el-time-picker
							is-range
							v-model="storeInfo.businessHoursArr"
							range-separator="至"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							placeholder="选择时间范围"
							value-format="HH:mm"
							></el-time-picker>
							
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label="isXiaochao ? '店铺Logo' : 'Logo'">
							<!-- 图片上传 -->
							<el-upload class="avatar-uploader" :action="httpUrl" :on-preview="handlePreview"
								:before-upload="beforeAvatarUpload" :on-success="onSuccess" :show-file-list="false">
								<img style="width: 100px;height: 100px;" v-if="logo" :src="logo" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label="isXiaochao ? '店铺证件照片' : '证件照片'">
							<!-- 图片上传 -->
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :limit="5"
								:on-success="onSuccess1">
								<i class="el-icon-plus"></i>
							</el-upload>

						</el-form-item>
					</div>

					<div>
						<div style="text-align: start;margin: 10px;">{{ isXiaochao ? '店铺简介' : '公司简介' }}</div>
						<el-form-item>
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess"
									:on-error="uploadError" />
								<quill-editor v-model="storeInfo.storeIntro" ref="myQuillEditor" class="editer"
									:options="editorOption" @ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<!-- <el-button v-show="title=='新增'" type="primary" @click="sure">添 加</el-button> -->
				<el-button v-show="title=='编辑'" type="primary" @click="edit">修 改</el-button>
			</div>
		</el-dialog>


		<el-dialog :closeOnClickModal="false" style="float:rigin" title="店铺审核" :visible.sync="dialogVisible2"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商家类型" cleartable>
							<el-select v-model="storeInfo.storeType" placeholder="" disabled>
								<el-option key="0" label="电商线上" :value="0">电商线上</el-option>
								<el-option key="1" label="九天小超" :value="1"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="用户名称">
							<el-select filterable remote v-model="userName" disabled class="big" placeholder="请选择" clear
								:remote-method="remoteMethod" @change="getUserId">
								<el-option v-for="item in accountList1" :key="item.id" :value="item.id"
									:label="item.username">
								</el-option>
							</el-select>
						</el-form-item>
		
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="店铺名称">
							<el-input type="text" v-model="storeInfo.storeName" placeholder="请输入店铺名称" />
						</el-form-item>
		
						<el-form-item label="手机号">
							<el-input type="text" v-model="storeInfo.phone" placeholder="请输入手机号" />
						</el-form-item>
						<el-form-item label="联系人">
							<el-input type="text" v-model="storeInfo.linkUser" placeholder="请输入联系人" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="店铺日提现额:">
							<el-input type="text" v-model="storeInfo.limitDayAmount" placeholder="请输入店铺日提现额" />
						</el-form-item>
							
					</div>
					<el-form-item label="服务区域">
						<el-input  style="width: 350px;" type="textarea"  show-word-limit v-model="storeInfo.serviceAreas" placeholder="请选择您的店铺可服务的区域或者范围" />
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="省/市/区">
							<el-col :span="13.5">
								<el-select clearable filterable v-model="storeInfo.provinceId" placeholder="请选择省"
									style="width:120px;margin-right:10px;" @change="provinceFocus">
									<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
								<el-select clearable filterable v-model="storeInfo.cityId" placeholder="请选择市"
									style="width:120px;margin:  0px 10px;" @change="cityFcus">
									<el-option v-for="item in cityList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
								<el-select clearable filterable v-model="storeInfo.areaId" placeholder="请选择区"
									style="width:120px;margin:  0px 10px;" @change="districtFcus">
									<el-option v-for="item in districtList" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</el-col>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="详细地址">
							<el-input type="text" v-model="storeInfo.address" placeholder="请输入详细地址" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="营业时间">
							<el-time-picker
							     is-range
							     v-model="storeInfo.businessHoursArr"
							     range-separator="至"
							     start-placeholder="开始时间"
							     end-placeholder="结束时间"
							     placeholder="选择时间范围"
							     value-format="HH:mm"
							></el-time-picker>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="店铺Logo">
							<!-- 图片上传 -->
							<el-upload class="avatar-uploader" :action="httpUrl" :on-preview="handlePreview"
								:before-upload="beforeAvatarUpload" :on-success="onSuccess" :show-file-list="false">
								<img style="width: 100px;height: 100px;" v-if="logo" :src="logo" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="店铺证件照片">
							<!-- 图片上传 -->
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :limit="5"
								:on-success="onSuccess1">
								<i class="el-icon-plus"></i>
							</el-upload>
		
						</el-form-item>
					</div>
		
					<div>
						<div style="text-align: start;margin: 10px;">店铺简介</div>
						<el-form-item>
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess"
									:on-error="uploadError" />
								<quill-editor v-model="storeInfo.storeIntro" ref="myQuillEditor" class="editer"
									:options="editorOption" @ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogVisible2 = false">取 消</el-button>
				<el-button  type="primary" @click="sure2">通 过</el-button>
				<el-button  type="primary" @click="edit2">驳 回</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :visible.sync="dialogshenheVisible" title="审核" :close-on-click-modal="false">
			<div style="display: flex;">
				<el-form :model="fromDetail" style="margin-left: 10px;">
					<el-span style="font-weight: 800;">原信息</el-span>
					<el-form-item>商户名称：{{fromDetail.storeName}}</el-form-item>
					<el-form-item>地址：{{fromDetail.province}}{{fromDetail.city}}{{fromDetail.area}}{{fromDetail.address}}</el-form-item>
					<el-form-item>商户邮箱：{{fromDetail.email}}</el-form-item>
					<el-form-item>商户LOGO：
					<img :src="fromDetail.storeLogo" alt="">
					</el-form-item>
					<el-form-item>商户证件：
						<el-button @click="lookcImages(fromDetail.cidImages)">查看</el-button>
					</el-form-item>
					<el-form-item>商户介绍：
					<el-button @click="lookxq(fromDetail.storeIntro)">查看</el-button>
					</el-form-item>
					
				</el-form>
				<el-form :model="toDetail" style="margin-left: 20px;">
					<el-span style="font-weight: 800;">修改后信息</el-span>
					<el-form-item>商户名称：{{toDetail.storeName}}</el-form-item>
					<el-form-item>地址：{{toDetail.province}}{{fromDetail.city}}{{toDetail.area}}{{toDetail.address}}</el-form-item>
					<el-form-item>商户邮箱：{{toDetail.email}}</el-form-item>
					<el-form-item>商户LOGO：
					<img :src="toDetail.storeLogo" alt="">
					</el-form-item>
					<el-form-item>商户证件：
						<el-button @click="lookcImages(toDetail.cidImages)">查看</el-button>
					</el-form-item>
					<el-form-item>商户介绍：
					<el-button @click="lookxq(toDetail.storeIntro)">查看</el-button>
					</el-form-item>
					
				</el-form>
			</div>
			<div>
				<el-span style="padding-left: 10px;">备注：</el-span>{{czobj.remark}}
			</div>
			<div slot="footer" class="dialog-footer" style="">
				<el-button @click="delcheckStore(czobj.id)">驳 回</el-button>
				<el-button type="primary" @click="shtg(czobj.id)">通 过</el-button>
			</div>
			
		</el-dialog>

		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
		<!-- 查看 -->
		<el-dialog title="照片" :visible.sync="showContentDialog" width="50%" :closeOnClickModal="false">
			<div>
				<div>
					<img style="width: 100%;" :src="storeInfo.storeLogo" />
				</div>
				<div>
					<img style="width: 100%;" :src="storeInfo.legalIdFace" />
				</div>
				<div>
					<img style="width: 100%;" :src="storeInfo.legalIdBack" />
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: '',
				httpUrl: urls,
				loading: false,
				storeList: [{}], //列表
				dialogVisible: false, // 审核
				dialogVisible2:false, //审核
				editDialogVisible: false, // 编辑
				showContentDialog: false, //查看证件照片
				dialogshenheVisible:false,
				dialogVisibleAdd: false,
				accountList: [],
				accountList1: [],
				czobj:{},
				fromDetail:{},
				toDetail:{},
				storeInfo: {
					userId: "",
					isHot: "",
					storeLogo: "",
					storeName: "",
					storeIntro: "",
					type: "",
					linkUser: "",
					phone: "",
					legalIdNumber: "",
					legalIdFace: "",
					legalIdBack: "",
					provinceId: "",
					cityId: "",
					// regionId: "",
					province: "",
					city: "",
					area: "",
					address: "",
					status:'',
					serviceAreas:'',
					businessHoursArr:['',''],
					storeClassId:'',
				},
				logo: "",
				cidImages: "",
				fileList: [],
				dialogVisibleImg: false,
				dialogImageUrl: '',
				goodsImages: [],
				provinceList: {},
				cityList: {},
				districtList: {},
				isSearchShow: false,
				userName: '',
				isXiaochao: false,
				storeLevelList:[
					{
						id:0,
						name: "小超",
					},
					{
						id:1,
						name: "经理",
					},
					{
						id:2,
						name: "县代",
					},
					{
						id:3,
						name: "区代",
					},
					{
						id:4,
						name: "市代",
					},
					{
						id:5,
						name: "省代",
					},
					{
						id:6,
						name: "运营中心",
					},
				],
				storeId: '', //授权用户id
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				merchantId:'',
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				category:[],//经营类别
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				}

			};
		},
		watch: {
			storeInfo(val) {
				// console.log(val)
			}
		},
		methods: {
			goWineCooler(id) {
				this.$router.push({
					// path: '/store/wineCooler',
					name: 'wineCooler',
					params: {
						id
					}
				})
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				// this.goodsImages.remove(file.url);
				this.fileList = this.fileList.filter(item => item.uid !== file.uid)
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			onSuccess1(response, file) {
				// console.log(response)
				this.fileList.push({
					"url": response.message
				})
				// console.log("asda", this.fileList)
			},
			remoteMethod(query) {
				if (query.length >= 3) {
					this.loading = true;
					setTimeout(() => {
						this.$api.getUserNameList(this.$encrypt({
							phone: query,
							pageNum: 1,
							pageSize: 50
						})).then((res) => {
							res=JSON.parse(this.$decrypt(res.data))
							if (res.state == 'success') {
								this.accountList1 = res.data.list
								this.$forceUpdate()
							}
						})
						this.loading = false;
					}, 200);
				} else {
					this.options = [];
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreList()
			},
			showFile(info) {
				this.showContentDialog = true
				this.storeInfo.storeLogo = info.storeLogo
				this.storeInfo.legalIdFace = info.legalIdFace
				this.storeInfo.legalIdBack = info.legalIdBack
			},
			
			toExamine(id){
				this.merchantId = id
				this.storeInfo = {}
				this.storeInfo.storeType = 1
				this.storeId = ""
				this.dialogVisible2 = true;
				this.logo = ""
				this.cidImages = ""
				this.fileList = [];
				//查询省
				this.$api.getArea(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
				this.$api.getStoreId(id).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.storeInfo = res.data
						this.storeInfo.storeType = 1
						  
						let listimg = []
						if (res.data.cidImages) {
							this.storeInfo.cidImages = res.data.cidImages
							this.fileList.push({
								url: this.storeInfo.cidImages
							})
						}
						this.logo = this.storeInfo.storeLogo
						this.cidImages = this.storeInfo.cidImages
						if (this.storeInfo.provinceId) {
							this.$api.getArea(this.storeInfo.provinceId).then((res) => {
								if (res.state == 'success') {
									this.cityList = res.data
								}
							})
						}
						if (this.storeInfo.cityId) {
							this.$api.getArea(this.storeInfo.cityId).then((res) => {
								if (res.state == 'success') {
									this.districtList = res.data
								}
							})
						}
				
					}
				})
			},
			agianExamine(item){
				// console.log(item);
				this.dialogshenheVisible = true
				
			},
			// 通过审核
			sure2(){
				// console.log(this.merchantId);
				let data = {
					id:this.merchantId,
					checkState:1
				}
				this.$api.exAmine(this.$encrypt(data)).then(res=>{
					// console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible2 = false;
						this.getStoreList()
					}
				})
			},
			// 审核驳回
			edit2(){
				this.editDialogVisible = true;
			},
			//店铺审核
			editStoreInfoCheck() {
				// console.log(this.form.refuseReason);
					let data = {
						id:this.merchantId,
						refuseReason: this.form.refuseReason,
						checkState:2
					}
					this.$api.exAmine(this.$encrypt(data)).then(res=>{
						
						if(res.state == 'success'){
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.dialogVisible2 = false;
							this.getStoreList()
						}
					})
				// if (checkState == 2) {
				// 	//通过驳回
				// 	var data = {
				// 		id: this.storeId,
				// 		checkState: checkState,
				// 		refuseReason: this.form.refuseReason
				// 	}
				// } else {
				// 	//通过审核
				// 	var data = {
				// 		id: id,
				// 		checkState: checkState
				// 	}
				// }
				// this.$api.editStoreInfoCheck(data).then((res) => {
				// 	if (res.state == 'success') {
				// 		this.$message({
				// 			message: res.message,
				// 			type: 'success'
				// 		});
				// 		this.editDialogVisible = false
				// 		this.getStoreList()
				// 	} else {
				// 		this.$message.error(res.message);
				// 	}
				// })
			},
			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			//审核驳回弹窗打开
			editialogVisible(id) {
				this.form.refuseReason = ""
				this.storeId = id
				this.editDialogVisible = true;
			},
			getCate(e){
				// console.log(e);
				let obj = {}
				
			},
			//查询用户信息
			getUserId(e) {
				// console.log(e)
				let obj = {};
				// console.log(this.accountList1,e)
				obj = this.accountList1.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.userId = obj.id
			},
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.province = obj.name
				this.storeInfo.cityId = ""
				this.storeInfo.regionId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.city = obj.name
				this.storeInfo.regionId = ""
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},
			districtFcus(e) {
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.area = obj.name
			},
			// 店铺编辑弹窗
			async dialogVisibleFun(id,storeCID) {
				this.storeInfo = {}
				// this.storeInfo.storeType = 1
				
				this.storeId = ""
				this.dialogVisible = true;
				this.logo = ""
				this.cidImages = ""
				this.fileList = [];
				//查询省
				this.$api.getArea(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
				if (id) {
					// console.log(id);
					this.storeId = id
					await this.$api.getStoreId(this.storeId).then((res) => {
						res.data=JSON.parse(this.$decrypt(res.data)).data
						if (res.state == 'success') {
							this.isXiaochao = res.data.isXiaochao
							this.storeInfo = res.data
							this.storeInfo.storeType = 1
							this.storeInfo.storeClassId = Number(storeCID)
							// console.log(this.storeInfo)
							// this.storeInfo.businessHoursArr = ["09:05", "18:05"]
							let listimg = []
							if (res.data.cidImages) {
								// listimg = JSON.parse(res.data.cidImages)
								// this.storeInfo.cidImages = []
								// listimg.map((item, index) => {
								// 	this.storeInfo.cidImages.push({
								// 		url: item
								// 	})
								// })
								this.storeInfo.cidImages = res.data.cidImages
								this.fileList.push({
									url: this.storeInfo.cidImages
								})
							}
							this.logo = this.storeInfo.storeLogo
							this.cidImages = this.storeInfo.cidImages
							if (this.storeInfo.provinceId) {
								this.$api.getArea(this.storeInfo.provinceId).then((res) => {
									if (res.state == 'success') {
										this.cityList = res.data
									}
								})
							}
							if (this.storeInfo.cityId) {
								this.$api.getArea(this.storeInfo.cityId).then((res) => {
									if (res.state == 'success') {
										this.districtList = res.data
									}
								})
							}

						}
					})
				} 
			},
			//新增商品
			sure() {
				this.storeInfo.storeLogo = this.logo
				this.storeInfo.status = 1
				let obj = {
					isXiaochao: this.isXiaochao
				}
				this.storeInfo.cidImages = []
				this.fileList.map(item => {
					// console.log(item.url)
					this.storeInfo.cidImages.push(item.url)
				})
				this.storeInfo.cidImages = this.storeInfo.cidImages.join(",")
				let data = Object.assign(this.storeInfo,obj)
				this.$api.addStore(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleAdd = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
					}
				})

			},
			//编辑
			edit() {
				// console.log(this.isXiaochao)
				if(this.isXiaochao){
					this.storeInfo.id = this.storeId
					this.storeInfo.cidImages = []
					this.fileList.map(item => {
						// console.log(item.url)
						this.storeInfo.cidImages.push(item.url)
					})
					this.storeInfo.cidImages = this.storeInfo.cidImages.join(",")
				
					this.storeInfo.storeLogo = this.logo
					let obj = {
						isXiaochao: this.isXiaochao
					}
					let data = Object.assign(this.storeInfo,obj)
					// console.log(data)
					this.$api.updateStore(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.dialogVisible = false;
							this.getStoreList();

						} else {
							this.$message.error(res.message);
						}
					})
				}else {
					this.storeInfo.id = this.storeId
					this.storeInfo.storeLogo = this.logo
					this.storeInfo.cidImages = []
					this.fileList.map(item => {
						// console.log(item.url)
						this.storeInfo.cidImages.push(item.url)
					})
					this.storeInfo.cidImages = this.storeInfo.cidImages.join(",")
					let obj = {
						isXiaochao: this.isXiaochao
					}
					let data = Object.assign(this.storeInfo,obj)
					// console.log(data)
					this.$api.updateStore(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.dialogVisible = false;
							this.getStoreList();

						} else {
							this.$message.error(res.message);
						}
					})
				}
			},
			//禁用启用
			toDelete(row) {
				if (row.status == 0) {
					var str = "此操作将启用该店铺账号, 是否继续?"
				} else {
					var str = "此操作将禁用该店铺账号, 是否继续?"
				}
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.editStoreById(row.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreList()
			},
			getStoreList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					username: this.searchInfo.username,
					storeName: this.searchInfo.storeName,
					type: this.searchInfo.type,
					checkState: this.searchInfo.checkState,
					// orderType: 2,
					linkUser: this.searchInfo.linkUser
				}

				this.$api.getStoreList(this.$encrypt(data)).then((res) => { //管理列表
				res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('角色管理列表:', res);
					if (res.state == 'success') {
						this.storeList = res.data
						// console.log(this.storeList)
						this.loading = false
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			//上传店铺logo
			onSuccess(response, file, fileList) {
				// console.log(response);
				this.logo = response.message;
			},
			//上传店铺logo
			// onSuccess1(response, file, fileList) {
			// 	console.log(response);
			// 	this.cidImages = response.data;
			// },
			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdFace = res.data
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdBack = res.data
				})
			},

			// 点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			getUserList(e) {
				this.$api.getUserNameList(
					{
						username: e,
						pageNum: 1,
						pageSize: 20
					}
				).then((res) => {
					// console.log('获取无店铺用户列表--',res);
					this.accountList1 = res.data.list;
				})
			},
			add() {
				this.dialogVisibleAdd = true;
				this.storeInfo = {}
				this.storeId = ""
				this.logo = ""
				this.cidImages = ""
				this.userName = ""
				this.fileList = [];
				this.isXiaochao = false;
				// console.log(this.accountList1)
				this.$api.getArea(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
						// console.log('省级查询--',this.provinceList)
					}
				})
			},
			inputHandler() {
				this.isSearchShow = true
				if(this.userName === ''){
					this.isSearchShow = false
				}
				// console.log(this.userName)
				this.getUserList(this.userName)
			},
			selectStore(id,name) {
				this.storeInfo.userId = id
				this.userName = name
				this.isSearchShow = false
			}
		},

		created() {
			this.getStoreList();
			this.$api.findStoreClass().then(res=>{
				// console.log(res);
				if(res.state == 'success'){
					this.category = res.data.list
				}
			})
		}

	};
</script>

<style scoped="scoped">
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}


	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.searchBox {
		position: absolute;
		top: 50px;
		left: 0;
		z-index: 99;
		width: 232px;
		height: 100px;
		background: #fff;
		box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
		overflow: auto;
		
	}
</style>
